export const MappingAliases = {
  newHelp: '/newhelp',
  getStarted: '/getstarted',
  waitingAreas: '/rc/Content/A_PageHelp/Page_WaitingAreasOverview.htm',
  meetingRooms: '/rc/Content/D_Articles/VCM/VCM_MeetingRoomArticleUser.htm',
  reports: APP.EXTERNAL_LINKS.Report.HelpAboutReportPage,
  beginconsultPDF: '/beginconsultPDF',
  attendmeetingPDF: '/attendmeetingPDF',
  callscreenPDF: '/callscreenPDF',
  usertroubleshooting: '/usertroubleshooting',
  posters: '/rc/Content/R_ResourceCentre/Use/AllRec_Quick%20start.htm',
  makingcalls: '/makingcalls',
  techguide: '/techguide',
  testVideoCall: '/rc/Content/D_Articles/TestingSetup.htm',
  support: '/support',
  resourcecentre: '/resourcecentre',
  intro: '/intro',
  new: '/new',
  terms: '/terms',
  privacy: '/privacy',
  cookies: '/cookies',
};
